import { DOCUMENT } from '@angular/common';
import { SessionStorageService } from './sessionStorage.service';
import { LocalStorageService } from './localStorage.service';
import { Observable, Subject, filter, takeUntil } from 'rxjs';
import { ElementRef, Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { Theme } from '../../helper/theme';
import { Meta } from '@angular/platform-browser';



@Injectable()
export class BodyService {
    private click: Subject<MouseEvent> = new Subject<MouseEvent>();
    private themeChanged: Subject<Theme> = new Subject<Theme>();

    public currentThemeKey: string = "currentTheme";
    private currentTheme: Theme = Theme.light;
    private renderer: Renderer2; 
    constructor(@Inject(DOCUMENT) private document: Document,
        private rendFactory: RendererFactory2,
        private localStorage: LocalStorageService,
        private sessionStorage: SessionStorageService) {
        this.renderer = rendFactory.createRenderer(null, null);
        this.InitTheme();
    }

    public InitTheme = () => {
        this.currentTheme = this.sessionStorage.getObject<Theme>(this.currentThemeKey) ||
            this.localStorage.getObject<Theme>(this.currentThemeKey)
            || Theme.light;

        this.applyTheme();
    }

    public applyAnonymous = () => {
        this.renderer.addClass(this.document.body, "home");
        this.renderer.removeClass(this.document.body, "mark-tool-dark-theme");
        this.renderer.addClass(this.document.body, "mark-tool-light-theme");
        
    }

    public deleteAnonymous = () => this.renderer.removeClass(this.document.body, "home");

    public getThemeChanged = (): Observable<Theme> => {
        return this.themeChanged.asObservable();
    }

    public getClick = (): Observable<MouseEvent> => {
        return this.click.asObservable();
    }

    public clickEvent = (element: () => ElementRef, cancelToken: Subject<void>): Observable<MouseEvent> =>
        this.click.asObservable()
            .pipe(
                filter(event => element() != null && !(element().nativeElement as HTMLElement).contains(event.target as HTMLElement)),
                takeUntil(cancelToken));


    public emitClick = (event: MouseEvent) => {
        this.click.next(event);
    }

    public setTheme = (theme: Theme) => {
        this.currentTheme = theme;
        this.sessionStorage.saveObject<Theme>(this.currentThemeKey, theme);
        this.localStorage.saveObject<Theme>(this.currentThemeKey, theme);
        this.applyTheme();
        this.themeChanged.next(this.currentTheme);
    }

    private applyTheme = () => {
        this.removeThem();
        this.renderer.addClass(this.document.body, this.getTheme(this.currentTheme));

        let meta = this.renderer.createElement('meta');
        meta.setAttribute('name','theme-color');
        meta.setAttribute('content',this.getThemeColor(this.currentTheme));
        this.renderer.appendChild(this.document.head, meta);
    }

    public removeThem = () => {
        this.renderer.removeClass(this.document.body, this.getTheme(Theme.dark));
        this.renderer.removeClass(this.document.body, this.getTheme(Theme.light));
        let element = this.document.querySelectorAll('[name="theme-color"]');
        element.forEach((el)=> this.renderer.removeChild(this.document.head, el));
    }

    private getThemeColor = (theme: Theme): string => {
        switch (theme) {
            case Theme.light:
                return "#FFFFFF";
            case Theme.dark:
                return "#131722";
            default:
                return null;
        }
    }

    private getTheme = (theme: Theme): string => {
        switch (theme) {
            case Theme.light:
                return "mark-tool-light-theme";
            case Theme.dark:
                return "mark-tool-dark-theme";
            default:
                return null;
        }
    }


    public getThemState = (): Theme => this.currentTheme;
}

